module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"email":"Email","message":"Twoja wiadomość","firstName":"Imię","lastName":"Nazwisko","phone":"Numer telefonu","send":"Wyślij","additionalQuestion":"Wiadomość","success":"Dziękujemy, wkrótce się z Tobą skontaktujemy."}}')
  delete Component.options._Ctor
}
